<section class="header">
    <nlr-header></nlr-header>
</section>
<div class="container-fluid">
    @if (surveyFirm && hasMaintainFirmPermission()) {
        <div>
            <div class="h4">
                <span>{{title}}</span>
            </div>
            <form
                name="maintainFirmForm"
                #firmForm="ngForm"
                (ngSubmit)="save(firmForm)"
                novalidate>
                <div class="well">
                    <div class="row">
                        <div class="col-xs-5">
                            <label
                                class="control-label"
                                for="firm"
                                >Survey firm</label
                            >
                            <div
                                class="input-group"
                                ng-class="{'has-error': maintainFirmForm.firm.$invalid
                            && (maintainFirmForm.firm.$dirty || maintainFirmForm.$submitted)}">
                                <span class="input-group-addon">
                                    <i class="nlrp-icon nlrp-icon-edit"></i>
                                </span>
                                <input
                                    type="text"
                                    id="firm"
                                    name="firm"
                                    class="form-control"
                                    [value]="formattedFirm"
                                    disabled="true" />
                            </div>
                            @if (!formattedFirm) {
                                <div class="help-block">
                                    <span>Error!</span>
                                    <span>Survey firm not found.</span>
                                </div>
                            }
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12">
                            <label class="control-label">Logo</label>
                        </div>
                        <div class="col-xs-10">
                            @if (getImagePreviewString()) {
                                <div class="panel panel-default">
                                    <div class="panel-body">
                                        <img
                                            class="previewImage"
                                            [src]="getImagePreviewString()" />
                                    </div>
                                </div>
                            }
                            @if (!surveyFirm.firmLogo.fileName) {
                                <div>
                                    <textarea
                                        type="text"
                                        name="firmLogoFileName"
                                        class="form-control"
                                        placeholder="No logo supplied"
                                        [ngModel]="surveyFirm.firmLogo.fileName"
                                        (click)="attachFirmLogo()"
                                        [readonly]="true"></textarea>
                                </div>
                            }
                            @if (!surveyFirm.firmLogo) {
                                <div class="help-block">
                                    <span>Error!</span>
                                    <span>Invalid</span>
                                </div>
                            }
                        </div>
                        <div class="col-xs-2">
                            <i
                                (click)="attachFirmLogo()"
                                class="nlrp-icon nlrp-icon-paper-clip"
                                id="attachFile"
                                title="Click to attach a file"
                                tabindex="0"></i>
                            @if (surveyFirm.firmLogo) {
                                <i
                                    (click)="clear()"
                                    id="clear"
                                    class="nlrp-icon nlrp-icon-trash"
                                    title="Clear"
                                    tabindex="0"></i>
                            }
                        </div>
                    </div>
                    <br />
                    <div class="h4">
                        <span>NLR field defaults</span>
                    </div>
                    <div class="row">
                        <div class="col-xs-5">
                            <label
                                class="control-label"
                                for="firm"
                                >Default survey organisation email address</label
                            >
                            <div
                                class="input-group"
                                [ngClass]="{'has-error': surveyOrganisationPlanPdfEmailAddress | formFieldHasError}">
                                <span class="input-group-addon">
                                    <i class="nlrp-icon nlrp-icon-edit"></i>
                                </span>
                                <input
                                    type="email"
                                    #surveyOrganisationPlanPdfEmailAddress="ngModel"
                                    name="surveyOrganisationPlanPdfEmailAddress"
                                    id="surveyOrganisationPlanPdfEmailAddress"
                                    class="form-control"
                                    email
                                    [(ngModel)]="surveyFirm.surveyOrganisationPlanPdfEmailAddress" />
                            </div>
                            @if (surveyOrganisationPlanPdfEmailAddress | formFieldHasError) {
                                <div class="help-block">
                                    <span>Error!</span>
                                    <span>Invalid</span>
                                </div>
                            }
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12">
                            <label class="control-label required-input">Default lodgement receipt email address</label>
                            <div>
                                <label class="nlr-radio">
                                    <input
                                        type="radio"
                                        name="firmDefaultLodgementReceiptEmailAddress"
                                        id="firmLodgementReceiptEmailAddress"
                                        [value]="true"
                                        [ngModel]="surveyFirm.firmDefaultLodgementReceiptEmailAddress"
                                        (ngModelChange)="changeFirmDefaultLodgementReceiptEmailAddress()"
                                        required="true" />
                                    <span>Firm email address</span>
                                </label>
                                <label class="nlr-radio">
                                    <input
                                        type="radio"
                                        name="firmDefaultLodgementReceiptEmailAddress"
                                        id="firmLoggedOnEmailAddress"
                                        #firmDefaultLodgementReceiptEmailAddress="ngModel"
                                        ng-value="false"
                                        [value]="false"
                                        [(ngModel)]="surveyFirm.firmDefaultLodgementReceiptEmailAddress"
                                        (ngModelChange)="clearFirmEmailAddress()"
                                        ng-required="true"
                                        required="true" />
                                    <span>Logged on users email address</span>
                                </label>
                            </div>
                            @if (!firmDefaultLodgementReceiptEmailAddress) {
                                <div class="help-block">
                                    <span>Error!</span>
                                    <span>Please enter the email</span>
                                </div>
                            }
                        </div>
                        <div class="col-xs-5">
                            <div
                                class="input-group"
                                [ngClass]="{'has-error': firmEmailAddress | formFieldHasError}">
                                <span class="input-group-addon">
                                    <i class="nlrp-icon nlrp-icon-edit"></i>
                                </span>
                                <input
                                    type="email"
                                    name="firmEmailAddress"
                                    id="firmEmailAddress"
                                    email
                                    #firmEmailAddress="ngModel"
                                    class="form-control"
                                    [(ngModel)]="surveyFirm.firmEmailAddress"
                                    [readOnly]="!surveyFirm.firmDefaultLodgementReceiptEmailAddress"
                                    [required]="surveyFirm.firmDefaultLodgementReceiptEmailAddress" />
                            </div>
                            @if (firmEmailAddress | formFieldHasError) {
                                <div class="help-block">
                                    <span>Error!</span>
                                    <span>Invalid</span>
                                </div>
                            }
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12">
                            <label class="control-label">Default PDF watermark</label>
                        </div>
                        <div class="col-xs-5">
                            <div class="input-group">
                                <span class="input-group-addon corner"><i class="nlrp-icon nlrp-icon-edit corner-icon"></i></span>
                                <textarea
                                    class="form-control"
                                    name="defaultPdfWatermark"
                                    id="defaultPdfWatermark"
                                    [(ngModel)]="surveyFirm.defaultPdfWatermark"
                                    #defaultPdfWatermark="ngModel"
                                    placeholder="Enter watermark"
                                    rows="2"
                                    cols="60"
                                    maxlength="1000"
                                    title="Enter a watermark"
                                    required
                                    nlrPattern="[a-zA-Z0-9 ]*"></textarea>
                            </div>
                            @if (defaultPdfWatermark.valid) {
                                <p class="text-right">
                                    <span [textContent]="getPdfWatermarkCharactersRemaining()"></span>
                                    <span>characters remaining</span>
                                </p>
                            }
                            @if (defaultPdfWatermark.invalid) {
                                <div class="help-block">
                                    <span>Error!</span>
                                    <span>PDF watermark text is not valid.</span>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div
                        class="btn-toolbar"
                        role="toolbar"
                        aria-label="...">
                        <div
                            class="btn-group"
                            role="group"
                            aria-label="...">
                            <button
                                type="button"
                                id="saveBtn"
                                type="submit"
                                [disabled]="saveBtnDisabled"
                                class="btn btn-default nlr-btn-sm submit">
                                Save
                                <i
                                    class="nlrp-icon nlrp-icon-refresh-reload refresh-animate"
                                    style="display: none;"></i>
                            </button>
                        </div>
                        <div
                            class="btn-group"
                            role="group"
                            aria-label="...">
                            <button
                                type="button"
                                class="btn btn-warning nlr-btn-sm"
                                id="cancelBtn"
                                (click)="cancel()"
                                value="Cancel">
                                Cancel
                                <i
                                    class="nlrp-icon nlrp-icon-refresh-reload refresh-animate"
                                    style="display: none;"></i>
                            </button>
                        </div>
                    </div>
                    <!-- <div
              class="btn-group pull-right debugger"
              role="group">
              <button
                type="button"
                class="btn btn-default"
                ng-class="{'btn-default': !showModel, 'btn-success': showModel}"
                ng-click="showModel = !showModel"
                >Raw</button
                >
                <button
                  type="button"
                  class="btn btn-default"
                  ng-class="{'btn-default': !showSanitizedModel, 'btn-success': showSanitizedModel}"
                  ng-click="showSanitizedModel = !showSanitizedModel"
                  >Sanitized</button
                  >
                </div> -->
                </div>
                <!-- <div class="debugger row">
              <div
                ng-if="showModel"
                class="col-xs-6">
                <h6>Raw model</h6>
                <pre ng-bind="maintainFirmController.getModelJson()"></pre>
              </div>
              <div
                ng-if="showSanitizedModel"
                class="col-xs-6">
                <h6>Sanitized model</h6>
                <pre ng-bind="maintainFirmController.getSanitizedModelJson()"></pre>
              </div>
            </div> -->
            </form>
        </div>
    }

    @if (!hasMaintainFirmPermission()) {
        <div>
            <h1>You do not have permission to maintain firm details.</h1>
        </div>
    }
</div>
<section class="footer">
    <nlr-footer></nlr-footer>
</section>
